import isotope from 'isotope-layout/wp-content/themes/litea/dist/isotope.pkgd.min';
import {IsotopeDefaultOption} from './isotopeDefaultOption';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd';

const ITEM_GALLERY =  '.gallery-filter__items';
const GRID =  '.gallery-filter__content';
export class Gallery {

	/**
	 * @param filterizr
	 */

	constructor(isotope) {
		this.element = isotope;
		this.gridContainer = this.element.querySelector(GRID);
		this.item = this.element.querySelector(ITEM_GALLERY);
		this.navigation = this.element.querySelectorAll('.gallery-filter__buttons button');
		this.hash = this.getHash();
	}

	init() {
		this.initIsotope();
		this.processClickIfHash();
		this.initListeners();
	};

	initIsotope() {
		let options = IsotopeDefaultOption.get();
		options.itemSelector = ITEM_GALLERY;
		options.filter = '*';
		this.grid = new isotope(document.querySelector(GRID), options);
		
		imagesLoaded(this.gridContainer, function() {
			this.grid = new isotope(document.querySelector(GRID), options);
		});
	}

	initListeners() {
		for (let i = 0; i < this.navigation.length; i++) {
			this.navigation[i].addEventListener('click', this.navigationClick.bind(this));
		}
	}

	navigationClick(e) {
		let selector = e.target.getAttribute('data-filter');
		let name = e.target.getAttribute('id');
		if (name) {
			window.history.pushState('', '', '#' + name);
		} else {
			window.history.pushState('', '', '#');
		}
		this.grid.arrange({
			filter: selector,
			transitionDuration: '0.4s',
			stagger: 30,
			gutter: 10,
		});

		for (let i = 0; i < this.navigation.length; i++) {
			this.navigation[i].classList.remove('active');
		}
		if (e.target.classList.contains('active')) {
			e.target.classList.remove('active');
		} else {
			e.target.classList.add('active');
		}

	}

	getHash() {
		return window.location.hash.replace('#', '');
	}

	processClickIfHash() {

		let item = document.getElementById(this.hash);

		if (item) {
			let itemAttribute = item.getAttribute('data-filter');
			this.grid.arrange({
				filter: itemAttribute,
				transitionDuration: '0.4s',
				stagger: 30,
				gutter: 10,
			});
		}
	}

}
